






























































import _ from 'lodash';

import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Customer } from '@/models';


@Component
export default class CustomerList extends Vue {

	@Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;
	@Getter("customers/list") public list: Customer[];

	@Action("customers/getCustomers") getCustomers: () => Promise<void>;

	@Mutation("customers/setCurrent")
	public setCurrent: (customer: Customer) => void;

	@Action("customers/deleteCustomer") deleteStoreCustomer: (customer: Customer) => Promise<void>;

	public mounted() {
		Promise.all([this.getCustomers()]).catch((err: any) => this.$onecentral.displayError(err));
	}

	public editCustomer(customer: Customer): void {
		this.setCurrent(customer);
		this.$router.push({ name: "edit-customer", params: { id: customer.id || "" } });
	}

	public deleteCustomer(customer: Customer): void {
		this.$onecentral.confirmPrompt()
			.then(() => this.deleteStoreCustomer(customer))
			.then(() => Vue.toasted.success('Customer deleted'))
			.catch((err: any) => this.$onecentral.displayError(err));
	}

}
